const NAME = 'materialRipples';

import {MDCRipple} from '@material/ripple';
import {purgeEls} from '@netx/core/utils';

export default function (target) {
	if (!target || target.hasFunctionality(NAME)) return target;

	target.addInitializer((instance, opts = {}) => {
		let materialRipples = [];

		const cleanUp = () => {
			_.invoke(materialRipples, 'destroy');
			materialRipples = [];
		};

		// Hey, listen!
		instance
			.on('preRenderHook', cleanUp)
			.on('removeHook', cleanUp)
			.on('postRenderHook', () => {
				materialRipples = purgeEls(
					[...instance.el.querySelectorAll('.mdc-ripple-surface')],
					instance.getExcludedViews(),
				).map((el) => new MDCRipple(el));
			})
			.on('materialRipples:ripple', (el) => {
				const ripple = materialRipples.find((ripple) => ripple.root_ === el);
				if (!ripple) return;

				const foundation = ripple.foundation_;
				foundation.activate();
				foundation.deactivate();
			});
	}, NAME);

	return target;
}
